$(document).ready(function () {

    $("#recommend-submit-button").on('click', function (e) {
        e.preventDefault();

        var errorCaptchaElement = $('#error-captcha');
        if (typeof grecaptcha !== 'undefined' && grecaptcha.getResponse().length === 0) {
            errorCaptchaElement.show();
            return;
        }
        errorCaptchaElement.hide();

        var postData = {

            name: $("#user_name_input").val(),
            userEmail: $("#user_email_input").val(),
            friendEmail: $("#friend_email_input").val(),
            message: $("#message_input").val(),
            productId: $("#product_id_input").val(),
            captcha: grecaptcha.getResponse()
        };

        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";

        $.ajax({
            data: JSON.stringify(postData),
            type: 'POST',
            url: "/submit/recommend",
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            beforeSend: function (xhr) {
                xhr.setRequestHeader(header, token);
            },
            success: function (response) {
                if (response.status === "SUCCESS") {
                    $("#recommend_form_content").html("<h4>" + response.result[0] + "</h4>");
                } else {
                    var errorInfo = "";
                    for (var i = 0; i < response.result.length; i++) {
                        errorInfo += "<div class='text text-danger'>" + response.result[i] + "</div>";
                    }
                    var recommendErrorsElement = $("#recommend-errors");
                    recommendErrorsElement.html(errorInfo);
                    recommendErrorsElement.show();
                }

            }
        });
        grecaptcha.reset();
    });
});